'use client';

import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';

//* Styles
import PublicationsTemplateStyle from './style';

//* Components
const List = dynamic(() => import('./components/List'));

const PublicationsTemplate = ({ pageData, publicationCategoriesData }) => {
	const { title } = pageData.content;

	return (
		<PublicationsTemplateStyle>
			<Container>
				<List
					title={title}
					publicationCategoriesData={publicationCategoriesData}
				/>
			</Container>
		</PublicationsTemplateStyle>
	);
};

export default PublicationsTemplate;
